module.exports = __webpack_public_path__ + "static/media/learning-27.892e751d.png";